import { render, staticRenderFns } from "./training.vue?vue&type=template&id=228a671a&scoped=true&"
import script from "./training.vue?vue&type=script&lang=js&"
export * from "./training.vue?vue&type=script&lang=js&"
import style0 from "./training.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./training.vue?vue&type=style&index=1&id=228a671a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a671a",
  null
  
)

export default component.exports